import { createApiSaga } from '../../sagaGenerator';
import { apiGet } from '../../../middleware/api';
import {
  REFERENCE_SEARCH_REQUEST,
  REFERENCE_SEARCH_SUCCESS,
  REFERENCE_SEARCH_FAILURE,
  REFERENCE_HAVE_REQUEST,
  REFERENCE_HAVE_SUCCESS,
  REFERENCE_HAVE_FAILURE,

  REFERENCE_SEARCH_EQ_REGION_REQUEST,
  REFERENCE_SEARCH_EQ_REGION_SUCCESS,
  REFERENCE_SEARCH_EQ_REGION_FAILURE,
  REFERENCE_SEARCH_EQ_COUNTRY_REQUEST,
  REFERENCE_SEARCH_EQ_COUNTRY_SUCCESS,
  REFERENCE_SEARCH_EQ_COUNTRY_FAILURE,
  REFERENCE_SEARCH_EQ_AREA_REQUEST,
  REFERENCE_SEARCH_EQ_AREA_SUCCESS,
  REFERENCE_SEARCH_EQ_AREA_FAILURE,

  REFERENCE_SEARCH_VOL_COUNTRY_REQUEST,
  REFERENCE_SEARCH_VOL_COUNTRY_SUCCESS,
  REFERENCE_SEARCH_VOL_COUNTRY_FAILURE,
  REFERENCE_SEARCH_VOL_REGION_REQUEST,
  REFERENCE_SEARCH_VOL_REGION_SUCCESS,
  REFERENCE_SEARCH_VOL_REGION_FAILURE,
  REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST,
  REFERENCE_SEARCH_VOL_VOLCANO_NAMES_SUCCESS,
  REFERENCE_SEARCH_VOL_VOLCANO_NAMES_FAILURE,
  REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST,
  REFERENCE_SEARCH_VOL_MORPHOLOGIES_SUCCESS,
  REFERENCE_SEARCH_VOL_MORPHOLOGIES_FAILURE,

  REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_SUCCESS,
  REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_FAILURE,
  REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_SUCCESS,
  REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_FAILURE,
  REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS,
  REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_FAILURE,
  REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_SUCCESS,
  REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_FAILURE,
  REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS,
  REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE,

  REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_REGIONS_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_REGIONS_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_COUNTRIES_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_COUNTRIES_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_AREAS_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_AREAS_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_VALIDITIES_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_VALIDITIES_FAILURE,
  REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_CAUSES_SUCCESS,
  REFERENCE_SEARCH_TSUNAMI_CAUSES_FAILURE,

  REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_SUCCESS,
  REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_FAILURE,
  REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_SUCCESS,
  REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_FAILURE,
  REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_SUCCESS,
  REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_FAILURE,
  REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_COUNTRIES_SUCCESS,
  REFERENCE_SEARCH_DEPOSIT_COUNTRIES_FAILURE,

  REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST,
  REFERENCE_SEARCH_RUNUP_REGIONS_SUCCESS,
  REFERENCE_SEARCH_RUNUP_REGIONS_FAILURE,
  REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_RUNUP_COUNTRIES_SUCCESS,
  REFERENCE_SEARCH_RUNUP_COUNTRIES_FAILURE,
  REFERENCE_SEARCH_RUNUP_AREAS_REQUEST,
  REFERENCE_SEARCH_RUNUP_AREAS_SUCCESS,
  REFERENCE_SEARCH_RUNUP_AREAS_FAILURE,
  REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_SUCCESS,
  REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_FAILURE,
  REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST,
  REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_SUCCESS,
  REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_FAILURE,
  REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST,
  REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_SUCCESS,
  REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_FAILURE,
  REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST,
  REFERENCE_SEARCH_RUNUP_CAUSES_SUCCESS,
  REFERENCE_SEARCH_RUNUP_CAUSES_FAILURE,
  REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST,
  REFERENCE_SEARCH_RUNUP_VALIDITIES_SUCCESS,
  REFERENCE_SEARCH_RUNUP_VALIDITIES_FAILURE,

} from './referenceSearchReducer';


const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: REFERENCE_SEARCH_REQUEST,
  successType: REFERENCE_SEARCH_SUCCESS,
  failureType: REFERENCE_SEARCH_FAILURE,
});

const getHavesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/reference/have-values', ...action }),
  requestType: REFERENCE_HAVE_REQUEST,
  successType: REFERENCE_HAVE_SUCCESS,
  failureType: REFERENCE_HAVE_FAILURE,
});

const getEqRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/regions', ...action }),
  requestType: REFERENCE_SEARCH_EQ_REGION_REQUEST,
  successType: REFERENCE_SEARCH_EQ_REGION_SUCCESS,
  failureType: REFERENCE_SEARCH_EQ_REGION_FAILURE,
});

const getEqCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/countries', ...action }),
  requestType: REFERENCE_SEARCH_EQ_COUNTRY_REQUEST,
  successType: REFERENCE_SEARCH_EQ_COUNTRY_SUCCESS,
  failureType: REFERENCE_SEARCH_EQ_COUNTRY_FAILURE,
});

const getEqAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/earthquake/areas/${action.eqCountry}`, ...action }),
  requestType: REFERENCE_SEARCH_EQ_AREA_REQUEST,
  successType: REFERENCE_SEARCH_EQ_AREA_SUCCESS,
  failureType: REFERENCE_SEARCH_EQ_AREA_FAILURE,
});

const getVolRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: REFERENCE_SEARCH_VOL_REGION_REQUEST,
  successType: REFERENCE_SEARCH_VOL_REGION_SUCCESS,
  failureType: REFERENCE_SEARCH_VOL_REGION_FAILURE,
});

const getVolCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/countries', ...action }),
  requestType: REFERENCE_SEARCH_VOL_COUNTRY_REQUEST,
  successType: REFERENCE_SEARCH_VOL_COUNTRY_SUCCESS,
  failureType: REFERENCE_SEARCH_VOL_COUNTRY_FAILURE,
});

const getVolVolcanoNamesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/names', ...action }),
  requestType: REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST,
  successType: REFERENCE_SEARCH_VOL_VOLCANO_NAMES_SUCCESS,
  failureType: REFERENCE_SEARCH_VOL_VOLCANO_NAMES_FAILURE,
});

const getVolMorphologiesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/morphologies', ...action }),
  requestType: REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST,
  successType: REFERENCE_SEARCH_VOL_MORPHOLOGIES_SUCCESS,
  failureType: REFERENCE_SEARCH_VOL_MORPHOLOGIES_FAILURE,
});

const getVolLocRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST,
  successType: REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_SUCCESS,
  failureType: REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_FAILURE,
});

const getVolLocCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/countries', ...action }), // TODO: make sure it isn't "event-countries"
  requestType: REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST,
  successType: REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_SUCCESS,
  failureType: REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_FAILURE,
});

const getVolLocEruptionTimesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/eruption-times', ...action }),
  requestType: REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST,
  successType: REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS,
  failureType: REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE,
});

const getVolLocMorphologiesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/morphologies', ...action }),
  requestType: REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST,
  successType: REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS,
  failureType: REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_FAILURE,
});

const getVolLocStatusesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/statuses', ...action }),
  requestType: REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST,
  successType: REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_SUCCESS,
  failureType: REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_FAILURE,
});

const getTsuRegionsSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_REGIONS_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_REGIONS_FAILURE,
});

const getTsuCountriesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/countries', ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_COUNTRIES_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_COUNTRIES_FAILURE,
});

const getTsuAreasSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/areas/${action.tsuCountry}`, ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_AREAS_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_AREAS_FAILURE,
});

const getTsuRunupCountriesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/countries', ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_FAILURE,
});

const getTsuRunupAreasSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/runup/areas/${action.tsuRunupCountry}`, ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_FAILURE,
});

const getTsuRunupMeasurementTypesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_FAILURE,
});

const getTsuValiditiesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_VALIDITIES_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_VALIDITIES_FAILURE,
});

const getTsuCausesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST,
  successType: REFERENCE_SEARCH_TSUNAMI_CAUSES_SUCCESS,
  failureType: REFERENCE_SEARCH_TSUNAMI_CAUSES_FAILURE,
});


const getDepPublicationsSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/publication-types', ...action }),
  requestType: REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST,
  successType: REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_SUCCESS,
  failureType: REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_FAILURE,
});

const getDepGeologicAgesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/geologic-ages', ...action }),
  requestType: REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST,
  successType: REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_SUCCESS,
  failureType: REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_FAILURE,
});

const getDepBodiesOfWaterSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/bodies-of-water', ...action }),
  requestType: REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST,
  successType: REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_SUCCESS,
  failureType: REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_FAILURE,
});

const getDepCountriesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/countries', ...action }),
  requestType: REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST,
  successType: REFERENCE_SEARCH_DEPOSIT_COUNTRIES_SUCCESS,
  failureType: REFERENCE_SEARCH_DEPOSIT_COUNTRIES_FAILURE,
});

const getRunupRegionsSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_REGIONS_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_REGIONS_FAILURE,
});

const getRunupCountriesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/countries', ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_COUNTRIES_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_COUNTRIES_FAILURE,
});

const getRunupAreasSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/areas/${action.runupCountry}`, ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_AREAS_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_AREAS_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_AREAS_FAILURE,
});

const getRunupRunupCountriesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/countries', ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_FAILURE,
});

const getRunupRunupAreasSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/runup/areas/${action.runupRunupCountry}`, ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_FAILURE,
});

const getRunupRunupMeasurementTypesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_FAILURE,
});

const getRunupCausesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_CAUSES_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_CAUSES_FAILURE,
});

const getRunupValiditiesSagas = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST,
  successType: REFERENCE_SEARCH_RUNUP_VALIDITIES_SUCCESS,
  failureType: REFERENCE_SEARCH_RUNUP_VALIDITIES_FAILURE,
});

export const searchReferencesSagas = [
  searchReferencesSaga,
  getHavesSaga,

  getEqRegionsSaga,
  getEqCountriesSaga,
  getEqAreasSaga,

  getVolCountriesSaga,
  getVolRegionsSaga,
  getVolVolcanoNamesSaga,
  getVolMorphologiesSaga,

  getVolLocRegionsSaga,
  getVolLocCountriesSaga,
  getVolLocStatusesSaga,
  getVolLocMorphologiesSaga,
  getVolLocEruptionTimesSaga,

  getTsuRegionsSagas,
  getTsuCountriesSagas,
  getTsuAreasSagas,
  getTsuRunupCountriesSagas,
  getTsuRunupAreasSagas,
  getTsuRunupMeasurementTypesSagas,
  getTsuValiditiesSagas,
  getTsuCausesSagas,

  getDepPublicationsSagas,
  getDepGeologicAgesSagas,
  getDepBodiesOfWaterSagas,
  getDepCountriesSagas,

  getRunupRegionsSagas,
  getRunupCountriesSagas,
  getRunupAreasSagas,
  getRunupRunupCountriesSagas,
  getRunupRunupAreasSagas,
  getRunupRunupMeasurementTypesSagas,
  getRunupCausesSagas,
  getRunupValiditiesSagas,

];
